"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _shop = require("@/api/shop");
var _encrypt = require("@/utils/encrypt");
var _encrypted = require("@/api/encrypted");
var _setDialog = _interopRequireDefault(require("../components/setDialog.vue"));
var _excluded = ["exist"];
var _default = {
  components: {
    setWhiteBlackList: _setDialog.default
  },
  props: ['id'],
  data: function data() {
    return {
      loading: true,
      value: 0,
      platform_exist: false,
      platformId: '',
      formList: {}
    };
  },
  mounted: function mounted() {
    this.getShopInfo();
  },
  methods: {
    getShopInfo: function () {
      var _getShopInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, encryptInfo, platformRes, exist, rest;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _shop.shopBaseInfo)();
              case 3:
                res = _context.sent;
                console.log('res', res);
                if (!res.member_id) {
                  _context.next = 16;
                  break;
                }
                // 加密信息，查询plarform_info数据表是否存在对应的平台ID
                console.log('res', res.member_id);
                encryptInfo = (0, _encrypt.encrypt)(res.member_id.toString());
                console.log('encryptInfo', encryptInfo);
                if (!encryptInfo) {
                  _context.next = 16;
                  break;
                }
                this.platformId = encryptInfo;
                _context.next = 13;
                return (0, _encrypted.getPlatformInfoAPI)({
                  platform_id: encryptInfo
                });
              case 13:
                platformRes = _context.sent;
                console.log('platformRes', platformRes);
                if (platformRes.exist) {
                  // 判断当前供应商是否添加到了平台表中
                  exist = platformRes.exist, rest = (0, _objectWithoutProperties2.default)(platformRes, _excluded);
                  this.platform_exist = exist;
                  this.formList = rest;
                }
              case 16:
                this.loading = false;
                _context.next = 22;
                break;
              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);
              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 19]]);
      }));
      function getShopInfo() {
        return _getShopInfo.apply(this, arguments);
      }
      return getShopInfo;
    }()
  }
};
exports.default = _default;